import { render, staticRenderFns } from "./accept.vue?vue&type=template&id=86d29876&scoped=true&"
import script from "./accept.vue?vue&type=script&lang=js&"
export * from "./accept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d29876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86d29876')) {
      api.createRecord('86d29876', component.options)
    } else {
      api.reload('86d29876', component.options)
    }
    module.hot.accept("./accept.vue?vue&type=template&id=86d29876&scoped=true&", function () {
      api.rerender('86d29876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains_registration_requests/actions/accept.vue"
export default component.exports